module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/1b82381ee9acfa07343530149029e2d6.png";